
/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021, 2022
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';
	class Sunburst {
		get config(){
			return {
				'type':'Sunburst',
				'isRecommendable':false,
				'noDataQuery': true,
				'supportsPossibleKeyDrivers': true,
				'useFPDAsInsightsInput' : true,
				'ignoreElementColor': true,
				'doesNotSupportSortAction': true,
				'doesNotSupportTopBottomAction': true,
				'doesNotSupportFormatAction': true,
				'doesNotSupportAnnotations': true,
				'doesNotSupportOLAP': true,
				'doesNotSupportCustomGroupAction': true,
				'enableCustomDataSelection': true,
				'shouldLogFPDInsightMessages': true,
				'hideAggTypeInAxisLabels': true,
				'propertiesToSetBeforeData': [
					'widget.data.truncate'
				],
				'groupedProperty': {
					'widget.legend.color': ['widget.legend.titleColor'],
					'widget.legend.font': ['widget.legend.titleFont']
				},
				'slots': {
					'values': {
						icon: 'target',
						'actions': [
							'PossibleKeyDriverAction',
							'text'
						],
						'coachMark': {
							'titleResource': 'coachMarkTitleSpiralTarget',
							'contentResource': 'coachMarkContentSpiralTarget',
							'mappedOnly': true,
							'showPopover': true
						},
						'mldTitleProperty': 'values.title'
					}
				},
				'propertyPrefixes': {
					'legend': 'widget.legend'
				},
				'listenForPropChanges': [
					'treeMode',
					'topBottomTargetValue',
					'widget.legend.size'
				],
				'properties':{
					'values.title': {
						'multilingual': true
					},
					'widget.data.truncate': {
						active: false,
						defaultValue: true
					},
					'format.compact':{
						'active':false
					},
					'legendPosition':{
						'active':false
					},
					'legend.display':{
						'active':false
					},
					'effect.duration': {
						'active': false
					},
					'topBottomN': {
						'active': false
					},
					'topBottomTargetValue': {
						'active':false
					},
					'actions': {
						'active': false,
						'defaultValue': 'showSunburst'
					},
					'showInsights': {
						active: false
					},
					'treeMode': {
						active: false
					},
					'showMinimap': {
						active: false
					},
					'widget.legend.size': {
						'active': false
					},
					'widget.legend.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.titleColor': {
						'colorClass': true,
						'active': true
					}
				},
				tabs: {
					default: 'showSunburst',
					entries: [{
						id: 'showSunburst',
						resource: 'decisionSunburst'
					},{
						id: 'showTree',
						resource: 'decisionTree'
					},{
						id: 'showRules',
						resource: 'decisionRules'
					}]
				},
				config:{
					'include':[
						'widget.data.truncate',
						'widget.iterator',
						'widget.legend.display',
						'widget.legend.position',
						'showMinimap',
						'actions',
						'showInsights',
						'treeMode',
						'topBottomN',
						'topBottomTargetValue',
						'effect.duration',
						'widget.legend.color',
						'widget.legend.splitter',
						'widget.legend.font',
						'widget.legend.titleFont',
						'widget.legend.titleColor',
						'widget.legend.swatch.symbol.default',
						'custom_cont',
						'custom_cat',
						'widget.legend.size',
						'widget.legend.titleVisible',
						'values.title',
						'optimizeSize',
						'valueLabels.font',
						'valueLabels.color',
						'labels.contrast.color'
					],
					'exclude':[
					]
				},
				'usages':[
					'Advanced'
				],
				'supportsMaintainAxisScale': false
			};
		}
	}
	return Sunburst;
});
